export default __webpack_public_path__ + "static/media/song5.b85f0130.mp3";